export default "__VITE_ASSET__DgZEYU9K__"